import {
  ANNUAL,
  MONTHLY,
  MONTHLY_24,
  MONTHLY_26,
  WEEKLY,
  PROFESSOR_TEACHER,
  HOURLY,
  NONQM_DSCR
} from "../constants/income_calculator_types";

export const default_employment_information = {
  employer_name: "",
  phone: "",
  address: "",
  city: "",
  state: "",
  zip: "",
  position: "",
  start_date: "",
  line_of_work_years: "0",
  line_of_work_months: "0",
  ownership: "",
  employed_by_party_to_transaction: ""
};

export const default_income_source = {
  calculator: "",
  year_0: new Date().getFullYear().toString(),
  year_1: (new Date().getFullYear() - 1).toString(),
  description: "",
  w2_or_self_employed: "",
  years_on_the_current_job: "0",
  months_on_the_current_job: "0",
  base_income_0: "0",
  overtime_0: "0",
  bonuses_0: "0",
  commission_0: "0",
  base_income_1: "0",
  overtime_1: "0",
  bonuses_1: "0",
  commission_1: "0",
  tips_0: "0",
  tips_1: "0",
  tips_history_months: "0",
  employment_information: default_employment_information
};

export const default_annual_source = {
  ...default_income_source,
  calculator: ANNUAL
};

export const default_monthly_source = {
  ...default_income_source,
  calculator: MONTHLY
};

export const default_weekly_source = {
  ...default_income_source,
  calculator: WEEKLY,
  paymentsPerYear: "52"
};

export const default_monthly_24_source = {
  ...default_income_source,
  calculator: MONTHLY_24,
  paymentsPerYear: "24"
};

export const default_monthly_26_source = {
  ...default_income_source,
  calculator: MONTHLY_26,
  paymentsPerYear: "26"
};

export const default_teacher_source = {
  ...default_income_source,
  calculator: PROFESSOR_TEACHER,
  number_of_months_0: "12",
  number_of_months_1: "12"
};

export const default_hourly_source = {
  ...default_income_source,
  calculator: HOURLY,
  base_hours_per_week: "40",
  base_weeks_per_year: "52",
  overtime_hours_per_week: "1",
  overtime_weeks_per_year: "1"
};

// NonQM DSCR: the borrower qualifies on the subject property's rental cash flow.
// The rent roll (one row per rental unit) lives on the income source; its total is
// the qualifying income. The DSCR ratio (rents / PITIA) per loan is a decision aid
// shown in the calculator, computed live from the loans + subject property.
export const default_dscr_source = {
  ...default_income_source,
  calculator: NONQM_DSCR,
  dscr_address_street: null,
  dscr_address_csz: null,
  dscr_rent_roll: [{ notes: "", rent: "0" }]
};
